import AtendimentoOrdemServicoService from "@/services/AtendimentoOrdemServicoService";

export const atendimentoOrdemServico = {
  namespaced: true,
  state: {
    atendimentoOrdemServico: {},
  },
  actions: {
    getAtendimentoOrdemServico({ commit }, payload) {
      return AtendimentoOrdemServicoService.GetAtendimentoOrdemServico(
        payload
      ).then(
        (atendimentoOrdemServico) => {
          return Promise.resolve(atendimentoOrdemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postAtendimentoOrdemServico({ commit }, payload) {
      return AtendimentoOrdemServicoService.PostAtendimentoOrdemServico(
        payload
      ).then(
        (atendimentoOrdemServico) => {
          return Promise.resolve(atendimentoOrdemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putAtendimentoOrdemServico({ commit }, payload) {
      return AtendimentoOrdemServicoService.PutAtendimentoOrdemServico(
        payload
      ).then(
        (atendimentoOrdemServico) => {
          return Promise.resolve(atendimentoOrdemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteAtendimentoOrdemServico({ commit }, payload) {
      return AtendimentoOrdemServicoService.DeleteAtendimentoOrdemServico(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getAtendimentoOrdemServicoOData({ commit }, payload) {
      return AtendimentoOrdemServicoService.GetAtendimentoOrdemServicoOData(
        payload
      ).then(
        (atendimentoOrdemServico) => {
          return Promise.resolve(atendimentoOrdemServico);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default atendimentoOrdemServico;
